module.exports = __webpack_public_path__ + "img/texas_natural_ba_list.398d3628.jpg";